import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=11438b62&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=11438b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11438b62",
  null
  
)

export default component.exports